// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Action } from '@ngrx/store';
import { IAMUser } from '@app/core';

export enum UsersActionTypes {
  USERS_LOADING = '[Users] USERS_LOADING',
  USERS_LOAD_COMPLETE = '[Users] USERS_LOAD_COMPLETE',
  USERS_LOAD_FAILED = '[Users] USERS_LOAD_FAILED'
}

export class LoadingUsersAction implements Action {
  readonly type = UsersActionTypes.USERS_LOADING;
  constructor() {}
}

export class CompleteLoadUsersAction implements Action {
  readonly type = UsersActionTypes.USERS_LOAD_COMPLETE;
  constructor(public payload: IAMUser[]) {
    this.payload = payload;
  }
}

export class FailLoadUsersAction implements Action {
  readonly type = UsersActionTypes.USERS_LOAD_FAILED;
  constructor() {}
}

export type UsersActionsUnion = LoadingUsersAction | CompleteLoadUsersAction | FailLoadUsersAction;



// WEBPACK FOOTER //
// ./src/app/access-management/state/users.actions.ts